import React, { useState, useEffect, useRef, useContext, Component } from 'react';
import * as ReactDOM from 'react-dom/client';
import reactToWebComponent from 'react-to-webcomponent';
import PropTypes from 'prop-types';
import { Multiselect } from 'multiselect-react-dropdown';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Contact from '../Contact';
import Footer from '../Footer';
import { connect } from "react-redux";
import { setCategoryAction } from '../../actions/clientAction';
import { setMealsAction } from '../../actions/clientAction';
import { setAlternativeCategoriesAction } from '../../actions/clientAction';
import { setArrivalAction } from "../../actions/clientAction";
import { setDepartureAction } from "../../actions/clientAction";
import { setAdultAction } from "../../actions/clientAction";
import { setChildAction } from "../../actions/clientAction";
import { setChildAgeAction } from "../../actions/clientAction";
import { setLocationAction } from "../../actions/clientAction";
import { setAccommodationTypeAction } from "../../actions/clientAction";
import { setFoodAction } from "../../actions/clientAction";
import { setEatingHabitAction } from "../../actions/clientAction";
import { resetAction } from "../../actions/clientAction";
import { setFormDataAction } from '../../actions/formData';
import getAuth from '../../api/auth';
import getinquiriesForm from '../../api/inquiriesForm';
import sendFormData from '../../api/sendFormData';
import moment, { now } from 'moment';
import Swal from 'sweetalert2'
import Language from '../../language/language.json';
import LightenDarkenColor from '../../helpers/helper';

const mapState = state => ({
    client: state.client,
    footer: state.footer,
    contact: state.contact,
    formData: state.formData
});

const mapDispatchToProps = dispatch => ({

    setCategory: (payload) => dispatch(setCategoryAction(payload)),
    setMeals: (payload) => dispatch(setMealsAction(payload)),
    setAlternativeCategories: (payload) => dispatch(setAlternativeCategoriesAction(payload)),
    setArrival: (payload) => dispatch(setArrivalAction(payload)),
    setDeparture: (payload) => dispatch(setDepartureAction(payload)),
    setAdult: (payload) => dispatch(setAdultAction(payload)),
    setChild: (payload) => dispatch(setChildAction(payload)),
    setChildAge: (payload) => dispatch(setChildAgeAction(payload)),
    resetState: (payload) => dispatch(resetAction(payload)),
    setFormData: (payload) => dispatch(setFormDataAction(payload)),

    setLocation: (payload) => dispatch(setLocationAction(payload)),
    setAccommodationType: (payload) => dispatch(setAccommodationTypeAction(payload)),
    setFood: (payload) => dispatch(setFoodAction(payload)),
    setEatingHabit: (payload) => dispatch(setEatingHabitAction(payload))
});

const Client = (props) => {

    const category = props.client.category;
    const meals = props.client.meals;
    const alternative_categories = props.client.alternative_categories;
    const adult = props.client.adult;
    const child = props.client.child;
    const childAge = props.client.childAge;
    const [arrival, setArrivalDate] = useState(props.arrival);
    const [departure, setDepartureDate] = useState(props.departure);

    const [categoryOptions, setCategoryOptions] = useState([]);
    const [mealsOptions, setMealsOptions] = useState([]);
    const [alternativeCategoryOptions, setAlternativeCategoryOptions] = useState([]);

    const [token, setToken] = useState(props.token);
    const [uuid, setUuid] = useState(props.uuid);
    const [clientBearerToken, setClientBearerToken] = useState(localStorage.getItem('clientBearerToken'));

    const [clientInquiryToken, setClientInquiryToken] = useState();
    const [locationOptions, setLocationOptions] = useState([]);
    const [accommodationTypeOptions, setAccommodationTypeOptions] = useState([]);

    const location = props.client.location;
    const accommodationType = props.client.accommodationType;
    const [paramsName, setParamsName] = useState("");

    var localClientBearerToken = '';
    var localClientTokenExpiresAt = '';
    var localClientFormId = '';
    var localClientInquiryToken = '';

    let departureInputRef = HTMLInputElement | null;
    let categoryInputRef = HTMLInputElement | null;
    let mealsInputRef = HTMLInputElement | null;
    let alternative_categoriesInputRef = HTMLInputElement | null;
    let locationInputRef = HTMLInputElement | null;
    let accommodationTypeInputRef = HTMLInputElement | null;



    useEffect(() => {

        setDepartureDate(new Date().setDate(arrival.getDate() + 1))

        var clientTokenExpiresAtLocal = new Date(localClientTokenExpiresAt).getTime();

        (async () => {

            if (localClientBearerToken == '' || localClientBearerToken == null || (clientTokenExpiresAtLocal <= Date.now())) {

                await getAuth(token, uuid).then((data) => {
                    if (data) {
                        localStorage.setItem('clientBearerToken', data.token.token);
                        localStorage.setItem('clientTokenExpiresAt', data.token.expires_at);
                        localStorage.setItem('clientFormId', data.params.id);
                    }

                    localClientBearerToken = localStorage.getItem('clientBearerToken')
                    localClientTokenExpiresAt = localStorage.getItem('clientTokenExpiresAt')
                    localClientFormId = localStorage.getItem('clientFormId')

                    setClientBearerToken(localStorage.getItem('clientBearerToken'))

                    if (localClientBearerToken && localClientFormId) {

                        getinquiriesForm(localClientBearerToken, localClientFormId).then((inquiry) => {

                            if (inquiry) {

                                localClientInquiryToken = inquiry.inquiry_token;
                                setClientInquiryToken(inquiry.inquiry_token);

                                setMealsOptions(inquiry.params.caterings);

                                /** done 1 */
                                setCategoryOptions(inquiry.params.entities);

                                setParamsName(inquiry.params.paramsName);

                                /** done 3 */
                                setLocationOptions(inquiry.params.regions);

                                /** done 3 */
                                setAccommodationTypeOptions(inquiry.params.resources);

                                /** done 2 */
                                setAlternativeCategoryOptions((inquiry.params.specialDiets).filter((item) => item.name !== ''));

                            }
                        });
                    }
                });
            }

        })();

    }, []);

    const handleCategoryChange = (selectedList, selectedItem) => {
        const value = selectedList;
        props.setCategory(value);
    };

    const handleMealsChange = (selectedList, selectedItem) => {
        const value = selectedList;
        props.setMeals(value);
    };

    const handleAlternativeCategoriesChange = (selectedList, selectedItem) => {
        const value = selectedList;
        props.setAlternativeCategories(value);
    };

    const handleArrivalChange = (date) => {
        setArrivalDate(date);
        props.setArrival(date);
        setDepartureDate(new Date().setDate(date.getDate() + 1))
        props.setDeparture(new Date().setDate(date.getDate() + 1));
        departureInputRef?.handleFocus();
    };

    const handleDepartureChange = (date) => {
        setDepartureDate(date);
        props.setDeparture(date);
    };

    const handleAdultChange = (e) => {
        const value = e.target.value;
        props.setAdult(value);
    };

    const handleChildChange = (e) => {
        const value = e.target.value;
        props.setChild(value);
    };

    const handleChildAgeChange = (e) => {
        const value = e.target.value;
        props.setChildAge(value);
    };

    const handleLocationChange = (selectedList, selectedItem) => {
        const value = selectedList;
        props.setLocation(value);
    };

    const handleAccommodationTypeChange = (selectedList, selectedItem) => {
        const value = selectedList;
        props.setAccommodationType(value);
    };

    const handleSubmit = (event) => {

        event.preventDefault();

        const contact = props.contact;
        const client = props.client;
        const footer = props.footer;

        console.log('contact', contact);
        const entities = [];
        client.category.map(function (item) {
            entities.push(item.id);
        });

        const specialDiets = [];
        client.alternative_categories.map(function (item) {
            specialDiets.push(item.id);
        });

        const caterings = [];
        client.meals.map(function (item) {
            caterings.push(item.id);
        });

        const regions = [];
        client.location.map(function (item) {
            regions.push(item.id);
        });


        console.log(footer.privacy_policy);
        if (footer.privacy_policy == false) {
            Swal.fire({
                title: 'Ich bin mit der Speicherung, Verarbeitung und etwaigen Weitergabe meiner Anfrage ein­ver­standen (Datenschutzerklärung).',
                showConfirmButton: true,
                showCancelButton: false,
                confirmButtonText: "OK",
                // cancelButtonText: "Cancel",
                icon: 'error'
            }
            ).then((result) => {

                // Do Noting

            });

            return false;
        }

        const formData = {
            "contact": {
                "salutation_id": contact.salutation.length > 0 ? contact.salutation[0].id : 0,
                "last_name": contact.firstName,
                "first_name": contact.surname,
                "email": contact.email,
                "country_id": contact.land.length > 0 ? contact.land[0].id : 0,
                "street": contact.street,
                "zip": contact.plz,
                "city": contact.street,
                "phone": contact.telephone
            },
            "arrival": moment(client.arrival).format('DD.MM.YYYY'),
            "departure": moment(client.departure).format('DD.MM.YYYY'),
            "adults": client.adult,
            "is_exchange": footer.pass_request_to_other_landlords ? "true" : "false",
            "is_gdpr": footer.privacy_policy ? "true" : "false",
            "children": client.child,
            "children_age": client.childAge,
            "note": contact.message,
            "regions": regions,
            "entities": entities,
            "special_diets": specialDiets,
            "caterings": caterings

        };

        sendFormData(clientBearerToken, clientInquiryToken, formData).then((data) => {
            console.log(data.code);
            if (data.errors === undefined && data.code != 'E_VALIDATION_FAILURE') {

                props.resetState()
                Swal.fire({
                    title: 'Success',
                    showConfirmButton: false,
                    showCancelButton: false,
                    // confirmButtonText: "OK",
                    // cancelButtonText: "Cancel",
                    icon: 'success'
                }
                ).then((result) => {
                    //Do Nothing
                });
            }
            else if (data.code == 'E_VALIDATION_FAILURE') {
                Swal.fire({
                    title: data.message,
                    showConfirmButton: false,
                    showCancelButton: false,
                    icon: 'error'
                }
                ).then((result) => {
                    //Do Nothing
                });
            }
            else {
                console.log('error');
            }

        });

        return;
    }

    const [color, setColor] = useState(props.color);

    useEffect(() => {

        document.documentElement.style.setProperty('--widget-color', color);
        var LightColor = LightenDarkenColor(color, 50);
        var DarkColor = LightenDarkenColor(color, -20);
        document.documentElement.style.setProperty('--widget-color-light', LightColor);
        document.documentElement.style.setProperty('--widget-color-dark', DarkColor);

    }, []);

    return (
        <>
            <form onSubmit={handleSubmit}>
                <div className='main_form'>
                    <h3 className='form_title'>{Language[props.lang].client_form_title}</h3>
                    {
                        (categoryOptions.length > 0 || alternativeCategoryOptions.length > 0) &&
                        <div className='form_field_row'>
                            {
                                categoryOptions.length > 0 &&
                                <fieldset className={ alternativeCategoryOptions.length > 0 ? 'field_50' : 'field_100'   } >
                                    <label>{paramsName}</label>
                                    <div className='icon_box'>
                                        <Multiselect
                                            id='category'
                                            options={categoryOptions}
                                            selectedValues={category}
                                            onSelect={handleCategoryChange}
                                            // onRemove={onRemove} 
                                            displayValue="name"
                                            placeholder={Language[props.lang].category_placeholder}
                                            emptyRecordMsg=""
                                            avoidHighlightFirstOption={true}
                                            hidePlaceholder={true}
                                            showArrow={true}
                                            // style={multiselectstyle}
                                            showCheckbox={true}
                                            ref={node => { categoryInputRef = node; }}
                                        />
                                        <div className="bt_ico" onClick={() => categoryInputRef.onFocus()}><svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="chevron-down" className="svg-inline--fa fa-chevron-down " role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M224 416c-8.188 0-16.38-3.125-22.62-9.375l-192-192c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L224 338.8l169.4-169.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-192 192C240.4 412.9 232.2 416 224 416z"></path></svg></div>
                                    </div>
                                </fieldset>
                            }

                            {
                                alternativeCategoryOptions.length > 0 &&

                                <fieldset className={ categoryOptions.length > 0 ? 'field_50' : 'field_100'   } >
                                    <label>&nbsp;</label>
                                    <div className='icon_box'>
                                        <Multiselect
                                            id='alternative_categories'
                                            options={alternativeCategoryOptions}
                                            selectedValues={alternative_categories}
                                            onSelect={handleAlternativeCategoriesChange}
                                            // onRemove={onRemove} 
                                            displayValue="name"
                                            placeholder={Language[props.lang].alternative_categories_placeholder}
                                            emptyRecordMsg=""
                                            avoidHighlightFirstOption={true}
                                            hidePlaceholder={true}
                                            showArrow={true}
                                            // style={multiselectstyle}
                                            showCheckbox={true}
                                            ref={node => { alternative_categoriesInputRef = node; }}
                                        />
                                        <div className="bt_ico" onClick={() => alternative_categoriesInputRef.onFocus()}><svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="chevron-down" className="svg-inline--fa fa-chevron-down " role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M224 416c-8.188 0-16.38-3.125-22.62-9.375l-192-192c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L224 338.8l169.4-169.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-192 192C240.4 412.9 232.2 416 224 416z"></path></svg></div>
                                    </div>
                                </fieldset>

                            }
                        </div>
                    }
                    {
                        (locationOptions.length > 0 || accommodationTypeOptions.length > 0) &&
                        <div className='form_field_row'>
                            {
                                locationOptions.length > 0 &&
                                <fieldset className={ accommodationTypeOptions.length > 0 ? 'field_50' : 'field_100'   } >
                                    <label>{Language[props.lang].location}</label>
                                    <div className='icon_box'>
                                        <Multiselect
                                            id="location"
                                            options={locationOptions}
                                            selectedValues={location}
                                            onSelect={handleLocationChange}
                                            // onRemove={onRemove} 
                                            displayValue="name"
                                            placeholder={Language[props.lang].location_placeholder}
                                            emptyRecordMsg=""
                                            avoidHighlightFirstOption={true}
                                            hidePlaceholder={true}
                                            showArrow={true}
                                            // style={multiselectstyle}
                                            showCheckbox={true}
                                            ref={node => { locationInputRef = node; }}
                                        />
                                        <div className="bt_ico" onClick={() => locationInputRef.onFocus()}><svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="chevron-down" className="svg-inline--fa fa-chevron-down " role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M224 416c-8.188 0-16.38-3.125-22.62-9.375l-192-192c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L224 338.8l169.4-169.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-192 192C240.4 412.9 232.2 416 224 416z"></path></svg></div>
                                    </div>
                                </fieldset>
                            }
                            {
                                accommodationTypeOptions.length > 0 &&
                                <fieldset className={ locationOptions.length > 0 ? 'field_50' : 'field_100'   } >
                                    <label>{Language[props.lang].accommodationType}</label>
                                    <div className='icon_box'>
                                        <Multiselect
                                            id="accommodationType"
                                            options={accommodationTypeOptions}
                                            selectedValues={accommodationType}
                                            onSelect={handleAccommodationTypeChange}
                                            // onRemove={onRemove} 
                                            displayValue="name"
                                            placeholder={Language[props.lang].accommodationType_placeholder}
                                            emptyRecordMsg=""
                                            avoidHighlightFirstOption={true}
                                            hidePlaceholder={true}
                                            showArrow={true}
                                            // style={multiselectstyle}
                                            showCheckbox={true}
                                            // groupBy="category"
                                            ref={node => { accommodationTypeInputRef = node; }}
                                        />
                                        <div className="bt_ico" onClick={() => accommodationTypeInputRef.onFocus()}><svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="chevron-down" className="svg-inline--fa fa-chevron-down " role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M224 416c-8.188 0-16.38-3.125-22.62-9.375l-192-192c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L224 338.8l169.4-169.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-192 192C240.4 412.9 232.2 416 224 416z"></path></svg></div>
                                    </div>
                                </fieldset>

                            }

                        </div>
                    }
                    {
                        mealsOptions.length > 0 &&
                        <div className='form_field_row'>

                            <fieldset className='field_100' style={{ display: mealsOptions.length > 0 ? "block" : "block" }}>
                                <label>{Language[props.lang].meals}</label>
                                <div className='icon_box'>
                                    <Multiselect
                                        id='meals'
                                        options={mealsOptions}
                                        selectedValues={meals}
                                        onSelect={handleMealsChange}
                                        // onRemove={onRemove} 
                                        displayValue="name"
                                        placeholder={Language[props.lang].meals_placeholder}
                                        emptyRecordMsg=""
                                        avoidHighlightFirstOption={true}
                                        hidePlaceholder={true}
                                        showArrow={true}
                                        // style={multiselectstyle}
                                        showCheckbox={true}
                                        ref={node => { mealsInputRef = node; }}
                                    />
                                    <div className="bt_ico" onClick={() => mealsInputRef.onFocus()}><svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="chevron-down" className="svg-inline--fa fa-chevron-down " role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M224 416c-8.188 0-16.38-3.125-22.62-9.375l-192-192c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L224 338.8l169.4-169.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-192 192C240.4 412.9 232.2 416 224 416z"></path></svg></div>
                                </div>
                            </fieldset>
                        </div>
                    }
                    <div className='form_field_row'>
                        <label>{Language[props.lang].arrival}</label>
                        <fieldset className='field_50'>

                            <div className='icon_box'>
                                <DatePicker id="arrival" selected={arrival} onChange={handleArrivalChange} placeholder={Language[props.lang].arrival_placeholder} selectsStart startDate={arrival} minDate={moment().toDate()} calendarClassName="widget-calender" dateFormat="dd.MM.yyyy" />
                            </div>
                        </fieldset>
                        <fieldset className='field_50'>

                            <div className='icon_box'>
                                <DatePicker id="departure" selected={departure} onChange={handleDepartureChange} placeholder={Language[props.lang].departure_placeholder} selectsEnd startDate={arrival} endDate={departure} minDate={arrival} calendarClassName="widget-calender" dateFormat="dd.MM.yyyy" ref={node => { departureInputRef = node; }} />
                            </div>
                        </fieldset>
                    </div>
                    <div className='form_field_row'>
                        <label>{Language[props.lang].adult}</label>
                        <fieldset className='field_33'>
                            <div className='icon_box number_box'>
                                <input type="number" id='adult' placeholder={Language[props.lang].adult_placeholder} value={adult} onChange={handleAdultChange} required />
                                {/* <div className="bt_ico">
                                </div> */}
                            </div>
                        </fieldset>
                        <fieldset className='field_33'>
                            <div className='icon_box number_box'>
                                <input type="number" id='child' placeholder={Language[props.lang].child_placeholder} value={child} onChange={handleChildChange} required />
                                {/* <div className="bt_ico">
                                </div> */}
                            </div>
                        </fieldset>
                        {
                            child > 0 &&
                            <fieldset className='field_33' style={{ display: child > 0 ? "block" : "none" }}>
                                <div className='icon_box'>
                                    <input type="number" id='childAge' placeholder={Language[props.lang].childAge_placeholder} value={childAge} onChange={handleChildAgeChange} required={child > 0 ? 'required' : false} />
                                </div>
                            </fieldset>

                        }

                    </div>
                    <Contact type="Client" prefix="Client" lang={props.lang} token={props.token} uuid={props.uuid}></Contact>
                    <Footer type="Client" prefix="" lang={props.lang} ></Footer>
                    <div className='form_field_row button_box'>
                        <button type='submit'>{Language[props.lang].client_submit_button}</button>
                    </div>
                </div>
            </form>
        </>
    );
};


Client.propTypes = {
    lang: PropTypes.string,
    token: PropTypes.string,
    uuid: PropTypes.string,
    color: PropTypes.string,
    arrival: PropTypes.instanceOf(Date),
    departure: PropTypes.instanceOf(Date),
}

export default connect(mapState, mapDispatchToProps)(Client);